import { useEffect, useState } from 'react';
import { useLanguage } from '../i18n/useLanguage';

const THEME_KEY = 'theme';

const ThemeSwitcher = () => {
  const { language } = useLanguage();
  const [theme, setTheme] = useState<'light' | 'dark'>(() => {
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem(THEME_KEY);
      if (saved === 'dark' || saved === 'light') return saved;
      // Sistem teması
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
    return 'light';
  });

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
      localStorage.setItem(THEME_KEY, 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem(THEME_KEY, 'light');
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  const labels = {
    tr: {
      light: 'Açık moda geç',
      dark: 'Koyu moda geç',
    },
    en: {
      light: 'Switch to light mode',
      dark: 'Switch to dark mode',
    },
  } as const;

  return (
    <button
      onClick={toggleTheme}
      className="ml-4 flex items-center justify-center rounded-full border border-primary-200 p-2 text-primary-700 transition-colors hover:bg-primary-50 dark:border-primary-500 dark:text-primary-200 dark:hover:bg-primary-950/50 focus:outline-none focus:ring-2 focus:ring-primary-500"
      aria-label={theme === 'dark' ? labels[language].light : labels[language].dark}
      title={theme === 'dark' ? labels[language].light : labels[language].dark}
    >
      {theme === 'dark' ? (
        // Güneş ikonu
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-yellow-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <circle cx="12" cy="12" r="5" fill="currentColor" />
          <path stroke="currentColor" strokeWidth="2" d="M12 1v2m0 18v2m11-11h-2M3 12H1m16.95 7.07l-1.41-1.41M6.34 6.34L4.93 4.93m12.02 0l-1.41 1.41M6.34 17.66l-1.41 1.41" />
        </svg>
      ) : (
        // Ay ikonu
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-primary-700 dark:text-primary-200" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke="currentColor" strokeWidth="2" d="M21 12.79A9 9 0 1111.21 3a7 7 0 109.79 9.79z" />
        </svg>
      )}
    </button>
  );
};

export default ThemeSwitcher; 
